import React, { useEffect, useState } from 'react'
import { getAuthButtons, ISigningButton } from 'auth/constants/authMethods'
import './loginPage.scss'
import { useTranslation } from 'react-i18next'
import queryString from 'query-string'
import { customerDataApiService, ISblData, CookieType } from 'shared/index'
import { TFunction } from 'i18next'

const updatePxSbl = (t: TFunction) => {
	let _queryValues = queryString.parseUrl(
		window.location.search.toLowerCase(),
	).query
	const hasUrlQuery =
		_queryValues.authorizationcode || _queryValues.failedauthorizationcode
	if (sessionStorage.getItem(CookieType.Sbl) === 'ok') return

	if (hasUrlQuery) {
		//logic parse data, call sbl endpoint, fail message,
		let data = {
			applicationId: _queryValues.applicationid as unknown as number,
			authCode: hasUrlQuery,
			isSuccessful: _queryValues.status === 'ok',
		} as ISblData
		customerDataApiService
			.updateSbl(data, t)
			.then(() =>
				sessionStorage.setItem(
					CookieType.Sbl,
					_queryValues.status as string,
				),
			)
			.catch((error: Error) => {
				console.log(error)
			})
	}
}

function LoginPage() {
	const [content, setContent] = useState<ISigningButton>()
	const { initMethod, filteredMethods } = getAuthButtons(
		setContent,
		content?.type,
	)
	const { t } = useTranslation()

	useEffect(() => {
		updatePxSbl(t)
		setContent(initMethod)
		// eslint-disable-next-line
	}, [initMethod])

	return (
		<div className="h-100 login-bg">
			<div className="h-100 inner d-flex justify-content-center align-items-center w-100">
				{filteredMethods.map((i, key) => {
					return <div key={key}>{i.content}</div>
				})}
			</div>
		</div>
	)
}
export default LoginPage
